import gql from "graphql-tag";

export const MY_TAX_GET_COMBINED_DECLARATION = gql`
  query taxDeclarationCombined($_id: Int!) {
    taxDeclarationCombined(_id: $_id) {
      dateOfDeclaration
      state
      isEligibleTwo
      isEligibleThree
      isEligible
      dependents {
        dependentSerialNumber
        name
        taxNumber
        dependentType
        entitlementTitle
        placeOfBirth
        dateOfBirth
        childType
      }
      applyAlone
      applyTogether
      noRequestRelief
      taxReliefAmount
      taxReliefNumberOfChild
      spouseName
      spouseTaxNumber
      spouseEmployerName
      spouseEmployerTaxNumber
    }
  }
`;
